import React from "react";

function sap() {
  return (
    <>
      <section className="services" id="erp">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12">
              <div className="title text-center ">
                <h2>Our Services</h2>
              </div>
              <h4 className="text-color">
                <h3>
                  <b>( SAP )</b>
                </h3>
                <p>
                  <h5 className="text-color">
                    <b>
                      Do you know 77% of world's transaction revenue occues
                      through SAP!
                    </b>
                  </h5>
                </p>
              </h4>
              <p>
                SAP implementation enables the creation of an efficient work
                environment by integrating various work processes. This
                implementation demands expertise, experience, and high-accuracy
                to assure maximum results. Macrozion Techsystems provides a
                complete suite of SAP Implementation services including SAP
                Migration, Upgrade, Optimization, and Support. We combine
                industry best practices with agile methodologies to assure
                flawless and effective SAP implementation.{" "}
              </p>
            </div>

            <div className="col-md-7">
              {" "}
              <p>
                Our certified SAP professionals provide end-to-end support to
                clients by designing. planning, deploying, building and
                improving SAP solutions in a risk-free environment. We employ a
                systematic and phased approach for SAP implementation in the
                cloud, on-premises, and hybrid environments. Designing,
                building, and fine-tuning a SAP landscape in your organization
                may take years to perfect. By partnering with us, you can rely
                on our guidance and expertise to optimize the value of your SAP
                investment.
              </p>
              <br></br>
              <h5 className="text-left text-color">
                <b>Our SAP Solutions and Services</b>
              </h5>
              <ul className="feature-list text-left">
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> S/4 HANA
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> SAP Fiori
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> SAP
                  Third-party Integration
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> SAP PI/PO
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> SAP S/4
                  HANA Conversion
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> SAP CAI
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> SAP ARIBA
                  & CIG
                </li>
              </ul>
            </div>
            <br></br>
            <div className="col-md-5">
              <p>
                <img
                  src="./images/sap.png"
                  alt="Example1"
                  width="420"
                  height="320"
                ></img>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default sap;
